export const formatDateAndTime = (props) => {
	const start = new Date(props.StartTime)
	const end = new Date(props.EndTime)

	const date = start.toLocaleString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	})

	const startTime = start.toLocaleTimeString('en-US', {
		hour: 'numeric',
		minute: 'numeric',
	})

	const endTime = end.toLocaleTimeString('en-US', {
		hour: 'numeric',
		minute: 'numeric',
	})
	return `${date} (${props.IsAllDay ? 'All Day' : `${startTime} - ${endTime}`})`
}

export const formatDateAndTimeForChat = (isoString) => {
	const today = new Date()
	const messageDate = new Date(isoString)

	const date = messageDate.toLocaleString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	})

	const time = messageDate.toLocaleTimeString('en-US', {
		hour: 'numeric',
		minute: 'numeric',
	})

	const todayDate = today.toLocaleString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	})

	const yyyymmdd = isoString.slice(0, 10)

	const sameDay = todayDate === date

	return `${sameDay ? '' : yyyymmdd + ' '}${time}`
}

export const formatCommonDate = (date, withTime = false) => {
	if (!date) return '--'
	if (withTime) {
		return new Date(date).toLocaleString('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			hour: 'numeric',
			minute: 'numeric',
		})
	} else {
		return new Date(date).toLocaleString('en-US', {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
		})
	}
}

export const formatUtcToLocalDate = (value) => {
	if (!value) return '--'

	const d = new Date(value)
	if (Number.isNaN(d.getTime())) return '--'

	const year = d.getFullYear()
	const month = String(d.getMonth() + 1).padStart(2, '0')
	const day = String(d.getDate()).padStart(2, '0')

	return `${year}-${month}-${day}`
}